<page-heading [title]="'integrations.webhookRequests.title' | translate:{ code: code, uuid: uuid }" [description]="
    code && uuid
      ? ('integrations.webhookRequests.descriptionPrefix' | translate) +
        getWebhookIntegrationsURLbyCode()
      : ''
  " [hasBreadcrumb]="true" [breadcrumb]="breadcrumb" />

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12 input-trend-search">
            <input type="search" #searchBox class="form-control" [placeholder]="'integrations.webhookRequests.searchPlaceholder' | translate"
              (keyup)="search(searchBox.value)" />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (loadingContent) {
<content-loading-list />
}

<div class="card">
  @if (pager.total === 0) {
  <empty-records-component [subMessage]="'integrations.webhookRequests.emptySubMessage' | translate" [icon]="'mdi mdi-alert-circle-outline'"
    [message]="'integrations.webhookRequests.emptyMessage' | translate" />
  }
  
  @if(!loadingContent && pager.total > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'integrations.webhookRequests.columnDate' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.webhookRequests.columnCode' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.webhookRequests.columnUuid' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.webhookRequests.columnParams' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.webhookRequests.columnRequestBody' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (webhook of pager.list; track $index) {
        <tr (click)="view(webhook)" style="cursor: pointer;">
          <td>
            <span>
              {{ webhook.createdAt | timezoneDate : "DD/MM/YYYY" : getTimezoneCompanyCurrentUser() }}
            </span>
          </td>
          <td>
            <span class="text-truncate"> {{ webhook.metadata?.['code'] }}</span>
          </td>
          <td>
            <span> {{ webhook.metadata?.['uuid'] }}</span>
          </td>
          <td>
            <span>{{ getFieldsQuery(webhook) }} </span>
          </td>
          <td>
            <span> {{ getFieldsBody(webhook) }}</span>
          </td>
        </tr>
        }
      </tbody>
    </table>
    @if (pager.total > pager.perPage) {
    <paginator [pager]="pager" (onPager)="loadPage($event)" />
    }
  </div>
  }
</div>